/**
 * @typedef {object} AdditionalsFlatGroup
 * @property {string} title
 * @property {Array<AdditionalsFlatItem>} items
 */

/**
 * @typedef {object} AdditionalsFlatItem
 * @property {string} text
 * @property {'localState'|'ad'} modelRoot
 * @property {string} model
 * @property trueValue
 */

/**
 * @type {Object<string, Array<AdditionalsFlatGroup>>}
 */
export const additionalsFlatSimple = {
  sale: [
    {
      title: 'Общее',
      items: [
        { text: 'Окна во двор', model: 'hasYardView' },
        { text: 'Окна на улицу', model: 'hasStreetView' },
        { text: 'Балкон', model: 'balconiesCount', trueValue: 1 },
        { text: 'Лоджия', model: 'loggiasCount', trueValue: 1 },
      ],
    },
    {
      title: 'Комфорт',
      items: [
        { text: 'Раздельный санузел', model: 'separateWcsCount', trueValue: 1 },
        { text: 'Совмещённый санузел', model: 'combinedWcsCount', trueValue: 1 },
      ],
    },
  ],

  rent: [
    {
      title: 'Общее',
      items: [
        { text: 'Мебель в комнатах', model: 'hasFurniture' },
        { text: 'Мебель на кухне', model: 'hasKitchenFurniture' },
        { text: 'Окна во двор', model: 'hasYardView' },
        { text: 'Окна на улицу', model: 'hasStreetView' },
        { text: 'Балкон', model: 'balconiesCount', trueValue: 1 },
        { text: 'Лоджия', model: 'loggiasCount', trueValue: 1 },
      ],
    },
    {
      title: 'Техника',
      items: [
        { text: 'Холодильник', model: 'hasFridge' },
        { text: 'Посудомоечная машина', model: 'hasDishwasher' },
        { text: 'Стиральная машина', model: 'hasWasher' },
        { text: 'Телевизор', model: 'hasTv' },
        { text: 'Телефон', model: 'hasPhone' },
      ],
    },
    {
      title: 'Комфорт',
      items: [
        { text: 'Ванна', model: 'hasBathtub' },
        { text: 'Душевая кабина', model: 'hasShower' },
        { text: 'Кондиционер', model: 'hasConditioner' },
        { text: 'Интернет', model: 'hasInternet' },
        { text: 'Раздельный санузел', model: 'separateWcsCount', trueValue: 1 },
        { text: 'Совмещённый санузел', model: 'combinedWcsCount', trueValue: 1 },
      ],
    },
  ],
};
